import { Navigate, RouteObject } from 'react-router-dom';

import {
  ADMIN,
  ADMIN_PAGE_NOT_FOUND,
  AUTH,
  BLANK_LAYOUT_ROUTES,
  DASHBOARD,
  HOME,
  PAGE_NOT_FOUND
} from '@constants/routes';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import AdminRoutes from '@features/admin/routes';
import AuthRoutes from '@features/authentication/routes';
import BranchRoutes from '@features/branch-management/routes';
import BranchReportRoutes from '@features/branch-reports/routes';
import DashboardRoutes from '@features/dashboard/pages/routes';
import DocsRoutes from '@features/docs/routes';
import EventRoutes from '@features/event-registration/routes';
import ExpenseTrackerRoutes from '@features/expense-tracker/routes';
import FormRoutes, { FormWizardRoutes } from '@features/forms/routes';
import CreateGroup from '@features/group-management/pages/v2/create-group/CreateGroup';
import EditGroupV2 from '@features/group-management/pages/v2/edit-group/EditGroup';
import GroupRoutes from '@features/group-management/routes';
import HelpRoutes from '@features/help/routes';
import LeadManagementRoutes from '@features/lead-management/routes';
import MemberRoutes from '@features/member-management/routes';
import PageNotFoundRoutes, {
  AdminPageNotFoundRoutes
} from '@features/page-not-found/routes';
import PaymentDropoffRoutes from '@features/payment-dropoff/routes';
import QuickCollectRoutes from '@features/quick-collect/routes';
import ReportsRoutes from '@features/reports/routes';
import OrgRoutes from '@features/settings/routes';
import SubscriptionPlanRoutes from '@features/subscription/routes';
import TallyIntegrationsRoutes from '@features/tally-integrations/routes';
import TeamManagementRoutes from '@features/team-management/routes';
import TransactionsRoutes from '@features/transactions/routes';
import AdminLayout from '@layouts/admin-layout/AdminLayout';
import BlankLayout from '@layouts/blank-layout/BlankLayout';
import MainLayout from '@layouts/main-layout/MainLayout';
import { getLocalStorageItem } from '@utils/storage';

export const mainRoutes: RouteObject[] = [
  AuthRoutes,
  {
    path: HOME,
    element: (
      <Navigate
        to={
          getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)
            ? DASHBOARD
            : AUTH.LOGIN
        }
      />
    )
  },
  {
    element: <BlankLayout />,
    children: [
      {
        path: BLANK_LAYOUT_ROUTES.GROUP_CREATE,
        element: <CreateGroup />
      },
      {
        path: BLANK_LAYOUT_ROUTES.GROUP_EDIT,
        element: <EditGroupV2 />
      },
      ...FormWizardRoutes
    ]
  },
  {
    element: <MainLayout />, // Outlet in MainLayout will be replaced by matching element from below
    children: [
      ...GroupRoutes,
      ...BranchRoutes,
      ...DocsRoutes,
      ...TeamManagementRoutes,
      ...PageNotFoundRoutes,
      ...HelpRoutes,
      DashboardRoutes,
      ...TransactionsRoutes,
      ...PaymentDropoffRoutes,
      ...SubscriptionPlanRoutes,
      ...BranchReportRoutes,
      ReportsRoutes,
      ...QuickCollectRoutes,
      ...OrgRoutes,
      ...MemberRoutes,
      ...EventRoutes,
      ...FormRoutes,
      ...ExpenseTrackerRoutes,
      ...LeadManagementRoutes,
      ...TallyIntegrationsRoutes
    ]
  },
  {
    path: '*',
    element: <Navigate to={PAGE_NOT_FOUND} />
  }
];

export const adminRoutes: RouteObject[] = [
  AuthRoutes,
  {
    path: HOME,
    element: (
      <Navigate
        to={
          getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)
            ? ADMIN.KYC_DOCUMENTS
            : AUTH.LOGIN
        }
      />
    )
  },
  {
    element: <AdminLayout />,
    // Outlet in AdminLayout will be replaced by matching element from below
    children: [...AdminRoutes, ...AdminPageNotFoundRoutes]
  },
  {
    path: '*',
    element: <Navigate to={ADMIN_PAGE_NOT_FOUND} />
  }
];
